export interface PricingPeriod {
  debut: string; // Format "MM-DD"
  fin: string;   // Format "MM-DD"
}

export interface SummerPricing {
  periode: PricingPeriod;
  tarif_nuit: number;
  min_nuits: number;
}

export interface DegressiveTarif {
  reduction: number;
  nuits: number;
  tarif_sejour: number;
}

export interface OffSeasonPricing {
  periode: "hors_ete";
  tarif_nuit: number;
  min_nuits: number;
  tarifs_degressifs: DegressiveTarif[];
}

export interface PricingData {
  nom: string;
  tarification: (SummerPricing | OffSeasonPricing)[];
  forfait_menage: number;
}

export const pricingData: PricingData = {
  nom: "TY GWENNILI",
  tarification: [
    {
      periode: {
        debut: "07-04",
        fin: "08-28"
      },
      tarif_nuit: 240,
      min_nuits: 7
    },
    {
      periode: "hors_ete",
      tarif_nuit: 240,
      min_nuits: 2,
      tarifs_degressifs: [
        { reduction: 0, nuits: 2, tarif_sejour: 480 },
        { reduction: 15, nuits: 3, tarif_sejour: 612 },
        { reduction: 23, nuits: 4, tarif_sejour: 740 },
        { reduction: 30, nuits: 5, tarif_sejour: 840 },
        { reduction: 38, nuits: 6, tarif_sejour: 893 },
        { reduction: 44, nuits: 7, tarif_sejour: 940 }
      ]
    }
  ],
  forfait_menage: 120
};
